import axios from "./axiosConfig";

const inventoryService = {
  getAll() {
    return axios.get("/inventory/items");
  },

  create(data) {
    return axios.post("/inventory/items", data);
  },

  update(id, data) {
    return axios.put(`/inventory/items/${id}`, data);
  },

  delete(id) {
    return axios.delete(`/inventory/items/${id}`);
  },

  getInventory() {
    return axios.get("/inventory/items/inventory");
  },

  transfer(data) {
    return axios.post("/inventory/movements/transfer", data);
  },

  consume(data) {
    return axios.post("/inventory/movements/consume", data);
  },

  receive(data) {
    return axios.post("/inventory/movements/receive", data);
  },

  getMovements(filters = {}) {
    return axios.get("/inventory/movements", { params: filters });
  },

  updateMinStock(itemId, locationId, minStock) {
    return axios.put("/inventory/items/min-stock", {
      itemId,
      locationId,
      minStock,
    });
  },
};

export default inventoryService;
